module.exports = __webpack_public_path__ + "static/media/app-strore-btn.000186b7.svg";